export default "__VITE_PUBLIC_ASSET__699a982d__"